import { makeAutoObservable, runInAction } from "mobx"
import {
  ActionError,
  ActionResultStatus,
  ActionSuccess,
  QueryResponse,
} from "types/Global"
import { resultOrError } from "../../../utils/Global"
import { APIMethods, call } from "api/CloudAPI"
import { ValueAddedService } from "./types"

class ValueAddedServiceStore {
  // lists
  loadingValueAddedServiceList = false
  valueAddedServiceList: ValueAddedService[] = []

  // init function
  constructor() {
    makeAutoObservable(this)
  }

  // actions
  async fetchValueAddedServices(sgtin: string) {
    this.loadingValueAddedServiceList = true

    const body = {
      request: APIMethods.VAS_LISTALL,
      // TODO remove hardcoded value
      data: {
        organizationID: "Bosch",
      },
    }

    const [result, error] = await resultOrError<QueryResponse<any>>(
      call(
        "OrganizationRouter",
        {
          ...body,
        },
        "Bosch",
        "",
        "pass123"
      )
    )

    if (result) {
      const vasList: ValueAddedService[] = []

      runInAction(() => {
        ;(result as ValueAddedService[]).forEach((item) => {
          if (item.gtins.indexOf(sgtin) > -1) {
            vasList.push(item)
          }
        })
        this.valueAddedServiceList = vasList
        this.loadingValueAddedServiceList = false
      })
      return {
        status: ActionResultStatus.SUCCESS,
        result: result,
      } as ActionSuccess<number>
    } else {
      runInAction(() => {
        this.loadingValueAddedServiceList = false
      })
      return {
        status: ActionResultStatus.ERROR,
        error: error,
      } as ActionError
    }
  }
}

export default ValueAddedServiceStore
